import { trackGTMEvent } from "lib/utils";
import type { SubscriptionLevel } from "lib/types";

import type { BriefingType } from "../types";

type HandleBriefingCardTrackingProps = {
  briefing: BriefingType;
  path: string;
  readerSubscriptionLevel: SubscriptionLevel;
  track: (
    eventName: string,
    properties: { [key: string]: any }
  ) => Promise<void>;
  component: string;
};

export const handleBriefingCardTracking = async ({
  briefing,
  path,
  readerSubscriptionLevel,
  track,
  component,
}: HandleBriefingCardTrackingProps) => {
  trackGTMEvent({
    event: "Briefing PDF Click",
    briefingLocation: "Briefings Section",
    briefingTitle: briefing.title,
    subscriptionLevel: readerSubscriptionLevel,
  });

  await track("Briefings card click", {
    "Click link": briefing.url,
    Component: component,
    "Page path": path,
    "Click text": briefing.title,
  });
};
